import Vue from 'vue'
import App from '@/App.vue'
import store from '@/store'
import router from '@/router'

import '@/i18n'
import '@/util/filters'
import '@/util/directives'
import '@/util/fa-icons'
import './registerServiceWorker'

import vuescroll from 'vuescroll'
import 'vuescroll/dist/vuescroll.css'

import globalMixin from '@/mixins/global.mixin.js'
import UiComponents from './plugins/ui-components'

import VCalendar from 'v-calendar'
import Toasted from 'vue-toasted'
import Paginate from 'vuejs-paginate'

Vue.config.productionTip = false

Vue.use(VCalendar)
Vue.use(UiComponents)

Vue.mixin(globalMixin)

Vue.component('paginate', Paginate)

Vue.use(Toasted, {
  position: 'bottom-center',
  className: 'pro-toasts',
  duration: 2500
})

// TODO: move to v-scrollable
Vue.use(vuescroll, {
  ops: {
    bar: {
      background: '#D9D9D9',
      opacity: '.8'
    }
  }
})

Vue.directive('focus', {
  inserted: function (el, binding) {
    if (binding.value) {
      el.focus()
    }
  },
  update: function (el, binding) {
    if (binding.value) {
      el.focus()
    }
  }
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
